import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import whoRatings from "../../../../src/data/articles/cube-prospective-doctor-who/who-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  whoRatings,
  ProspectiveIntro,
  React
};